import React from 'react'

export default function Contact() {
    return (
        <div>
            <section className="contact-section ptb-200">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-4">
                            <div className="contact-info-address">
                                <h3>Quick Contact</h3>
                                <div className="info-contact">
                                    <i className="flaticon-pin"></i>
                                    <h3>Location</h3>
                                    <span>
                                        205 Namungoona, Kampala
                                <br />
                                Uganda, East Africa
                            </span>
                                </div>
                                <div className="info-contact">
                                    <i className="flaticon-call"></i>
                                    <h3>Call Us</h3>
                                    <span>
                                        <a href="tel:+256-772-259323">256 772-259323 </a>
                                    </span>
                                    <br/>
                                    <span>
                                        <a href="tel:+256-414580708">256 414-580708 </a>
                                    </span>
                                    <br/>
                                    <span>
                                        <a href="tel:+256-706 080391">256 706-080391 </a>
                                    </span>
                                </div>
                                <div className="info-contact">
                                    <i className="flaticon-email"></i>
                                    <h3>Email Us</h3>
                                    <span>
                                        <a href="mailto: hello@childhope.com">support@childhope.com</a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8">
                            <div className="contact-area">
                                <div className="contact-content">
                                    <h3>Lets talk</h3>
                                    <p>
                                     If you have any inquiries about your sponsorship, need help with how Child Hope works, or just want to say ‘hi’, please feel free to reach out to our Child Hope team today!
                            </p>

                                </div>
                                <div className="contact-form">
                                    <form id="contactForm" novalidate="true">
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <input type="text" name="name" id="name" className="form-control" required
                                                        data-error="Please enter your name" placeholder="Name" />
                                                    <div className="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <input type="text" name="phone_number" id="phone_number" required
                                                        data-error="Please enter your number" className="form-control"
                                                        placeholder="Phone" />
                                                    <div className="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <input type="email" name="email" id="email" className="form-control" required
                                                        data-error="Please enter your email" placeholder="email" />
                                                    <div className="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div className="col-lg-6 col-md-6">
                                                <div className="form-group">
                                                    <input type="text" name="msg_website" id="msg_website" className="form-control"
                                                        required data-error="Please enter your website" placeholder="Website" />
                                                    <div className="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12 col-md-12">
                                                <div className="form-group">
                                                    <textarea name="message" className="form-control" id="message" cols="30"
                                                        rows="6" required data-error="Write your message"
                                                        placeholder="Write Something"></textarea>
                                                    <div className="help-block with-errors"></div>
                                                </div>
                                            </div>

                                            <div className="col-lg-12">
                                                <div className="send-btn">
                                                    <button type="submit" className="default-btn">
                                                        Contact us
                                                <i className="flaticon-right"></i>
                                                        <span></span>
                                                    </button>
                                                </div>
                                                <div id="msgSubmit" className="h3 text-center hidden"></div>
                                                <div className="clearfix"></div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="map-section">
        <iframe title="Map"
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyCfXnfJAD4JnbM5JjF8zRD4HxW_0cc1MLU
            &q=Disciples Of Christ Church,Namungoona, Unnamed Road, Kampala">
        </iframe>
    </div>
        </div>
    )
}
